import {
  START_DUPLICATING_EVENT,
  CANCEL_DUPLICATING_EVENT,
  DUPLICATE_EVENT
} from 'actions/Types';

export default (state = null, action) => {
  if (
    action.type === CANCEL_DUPLICATING_EVENT ||
    action.type === `${DUPLICATE_EVENT}_SUCCESS`
  ) {
    return null;
  }

  if (action.type === START_DUPLICATING_EVENT) {
    return action.payload;
  }

  return state;
};
